var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7149 32.2734L34.9902 29V64L74.7149 60.7266C75.7603 60.7266 76.283 59.9712 76.283 58.964V34.2878C76.5444 33.0288 75.7603 32.2734 74.7149 32.2734ZM43.6147 55.187C43.6147 56.1942 42.8306 56.9496 41.7852 56.9496C40.7399 56.9496 39.9558 56.1942 39.9558 55.187V37.5611C39.9558 36.554 40.7399 35.7986 41.7852 35.7986C42.8306 35.7986 43.6147 36.554 43.6147 37.5611V55.187ZM53.2845 53.9281C53.2845 54.9353 52.5005 55.6906 51.4551 55.6906C50.4097 55.6906 49.6256 54.9353 49.6256 53.9281V38.5683C49.6256 37.5612 50.4097 36.8058 51.4551 36.8058C52.5005 36.8058 53.2845 37.5612 53.2845 38.5683V53.9281ZM62.9543 52.6691C62.9543 53.6763 62.1703 54.4317 61.1249 54.4317C60.0795 54.4317 59.2955 53.6763 59.2955 52.6691V39.8273C59.2955 38.8201 60.0795 38.0647 61.1249 38.0647C62.1703 38.0647 62.9543 38.8201 62.9543 39.8273V52.6691ZM71.5788 52.1655C71.5788 53.1727 70.7947 53.9281 69.7494 53.9281C68.704 53.9281 67.9199 53.1727 67.9199 52.1655V41.0863C67.9199 40.0791 68.704 39.3237 69.7494 39.3237C70.7947 39.3237 71.5788 40.0791 71.5788 41.0863V52.1655Z",
    fill: "url(#paint0_linear_3854_1408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3287 29L19.3067 32.2734C18.5227 32.5252 18 33.2806 18 34.036V58.7123C18 59.4677 18.5227 60.2231 19.3067 60.4749L31.3287 63.7482V29Z",
    fill: "url(#paint1_linear_3854_1408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3854_1408",
    x1: 55.662,
    y1: 29,
    x2: 55.662,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135FC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3854_1408",
    x1: 24.6644,
    y1: 29,
    x2: 24.6644,
    y2: 63.7482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135FC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personalIcon.551c44e840377971695f8882cd8d8d64.svg";
export { ForwardRef as ReactComponent };